import { useMemo } from 'react';
import { Navigate } from 'react-router';
import {
  PageCheckMagicLink,
  PageForgotPassword,
  PageLoginSignpost,
  PageLoginWithCode,
  PageNewPassword,
  PagePasswordLogin,
  PagePasswordlessLogin,
  PageSignUp,
  PageTokenLogin,
} from 'pages';
import { routes } from '../../routes';
import { FetchUserGuard } from '../fetch-user-guard';

export const usePublicWebRouter = () =>
  useMemo(
    () => [
      {
        element: <Navigate replace to="/login/magic-link" />,
        path: '/landing',
      },
      {
        element: <PageLoginSignpost />,
        path: routes.login.index,
      },
      {
        element: <PageLoginWithCode />,
        path: routes.login.code,
      },
      {
        children: [{ element: <PageTokenLogin />, index: true }],
        element: <FetchUserGuard useInitialAuthState />,
        path: routes.tokenLogin,
      },
      {
        element: <PageSignUp />,
        path: routes.signUp,
      },
      {
        element: <PagePasswordlessLogin />,
        path: '/login/magic-link',
      },
      {
        element: <PageCheckMagicLink />,
        path: '/magic-link/:token?',
      },
      {
        element: <PagePasswordLogin />,
        path: '/login/password',
      },
      {
        element: <PageForgotPassword />,
        path: '/forgot-password',
      },
      {
        element: <PageNewPassword />,
        path: '/new-password/:token?',
      },
    ],
    [],
  );
